/* Shared behavior for leveled-up blog articles (prefix ela-). Published as assets/ela.js.
   1. YouTube loads only on tap (no YouTube request before that).
   2. Graphic photos are built only on tap: the image URL lives in data-src, so crawlers
      and the first page load never fetch it.
   3. Month chart: tap or hover a month to update the numbers box.
   4. Charts and bars animate in when scrolled into view.
   5. FAQ: one answer open at a time. */
(function () {
  document.querySelectorAll('.ela-vid[data-ela-yt]').forEach(function (box) {
    var btn = box.querySelector('.ela-vid__btn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + box.getAttribute('data-ela-yt') + '?autoplay=1&playsinline=1&rel=0';
      f.title = box.getAttribute('data-ela-title') || 'Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      box.innerHTML = '';
      box.appendChild(f);
    });
  });

  document.querySelectorAll('.ela-gate[data-src]').forEach(function (g) {
    var btn = g.querySelector('button');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var srcs = g.getAttribute('data-src').split('|');
      var alts = (g.getAttribute('data-alt') || '').split('|');
      var wrap = document.createElement('div');
      wrap.className = srcs.length > 1 ? 'ela-gate__imgs' : 'ela-gate__one';
      srcs.forEach(function (u, i) {
        var f = document.createElement('figure');
        var im = document.createElement('img');
        im.src = u; im.alt = alts[i] || ''; im.loading = 'lazy';
        f.appendChild(im);
        if (srcs.length > 1) {
          var c = document.createElement('figcaption');
          c.textContent = i === 0 ? 'Before' : 'After';
          f.appendChild(c);
        }
        wrap.appendChild(f);
      });
      g.innerHTML = '';
      g.appendChild(wrap);
      g.classList.add('is-open');
    });
  });

  /* Reddit cards: on tap, swap the button for Reddit's official embed and (re)run widgets.js,
     which turns every unprocessed embed blockquote into the live post. */
  document.querySelectorAll('.ela-rcard[data-ela-rd]').forEach(function (card) {
    var btn = card.querySelector('button');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var a = card.querySelector('.ela-rcard__t a');
      var bq = document.createElement('blockquote');
      bq.className = 'reddit-embed-bq';
      bq.setAttribute('data-embed-height', '520');
      bq.setAttribute('data-embed-theme', 'light');
      var link = document.createElement('a');
      link.href = card.getAttribute('data-ela-rd');
      link.textContent = a ? a.textContent : 'View on Reddit';
      bq.appendChild(link);
      btn.replaceWith(bq);
      var w = card.querySelector('.ela-gate__w'); if (w) w.remove();
      var s = document.createElement('script');
      s.src = 'https://embed.reddit.com/widgets.js'; s.async = true; s.charset = 'UTF-8';
      document.body.appendChild(s);
    });
  });

  document.querySelectorAll('[data-ela-chart]').forEach(function (box) {
    var data = JSON.parse(box.getAttribute('data-ela-chart'));
    var pts = box.querySelectorAll('.ela-ch__pt');
    var f = function (v) { return '+' + (Math.round(v * 100) / 100).toFixed(2) + '"'; };
    var put = function (k, v) { var el = box.querySelector('[data-t="' + k + '"]'); if (el) el.textContent = v; };
    var set = function (i) {
      var d = data[i];
      if (!d) return;
      put('m', d.m); put('n', d.n); put('med', f(d.med)); put('p75', f(d.p75)); put('p90', f(d.p90));
      if (d.len != null) put('len', f(d.len));
      if (d.ge05 != null) put('ge05', Math.round(d.ge05) + '%');
      if (d.ge1 != null) put('ge1', Math.round(d.ge1) + '%');
      pts.forEach(function (p) { p.classList.toggle('is-on', +p.getAttribute('data-i') === i); });
    };
    box.querySelectorAll('.ela-ch__hit').forEach(function (h) {
      var i = +h.getAttribute('data-i');
      h.addEventListener('mouseenter', function () { set(i); });
      h.addEventListener('click', function () { set(i); });
    });
    set(data.length - 1);
  });

  var anim = document.querySelectorAll('[data-ela-anim]');
  if (!('IntersectionObserver' in window)) {
    anim.forEach(function (e) { e.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.2 });
    anim.forEach(function (e) { io.observe(e); });
  }

  var items = document.querySelectorAll('.ela-faq details');
  items.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      items.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });
})();

/* 18+ demo: the bar opens a warning; the <video> is only created after the viewer confirms. */
(function () {
  document.querySelectorAll('.ela-nsfw[data-ela-nsfw]').forEach(function (box) {
    var bar = box.querySelector('.ela-nsfw__bar'), body = box.querySelector('.ela-nsfw__body'), go = box.querySelector('.ela-nsfw__go');
    if (!bar || !body || !go) return;
    bar.addEventListener('click', function () { body.hidden = !body.hidden; });
    go.addEventListener('click', function () {
      var player = box.querySelector('.ela-nsfw__player');
      var v = document.createElement('video');
      v.src = box.getAttribute('data-ela-nsfw'); v.controls = true; v.playsInline = true; v.preload = 'auto';
      player.innerHTML = ''; player.appendChild(v);
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  });
})();
